import "../../style/termsModal/TermsModal.css";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import { useRecoilState, useSetRecoilState } from "recoil";
import { registerModalState } from "../../atoms/registerTerms";
import { termsState } from "../../atoms/termsIsAccepted";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";

const RegisterModal = () => {
  const [registerTerms, setRegisterTerms] = useRecoilState(registerModalState);

  const setTermsIsAccepted = useSetRecoilState(termsState);

  const handleTermsAccept = () => {
    setRegisterTerms(false);
    setTermsIsAccepted(true);
  };

  const handleTermsReject = () => {
    setRegisterTerms(false);
    setTermsIsAccepted(false);
  };

  const handleClose = () => {
    setRegisterTerms(false);
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={registerTerms}
      onClose={handleClose}
      closeAfterTransition
      className="terms-modal-wrapper"
    >
      <Fade in={registerTerms}>
        <Box
          className="terms-modal"
          style={{
            maxHeight: "90vh",
            overflowY: "auto",
          }}
        >
          <main>
            <section className="policies">
              <article>
                <br />
                <h1>Kullanıcı (Üyelik) Sözleşmesi</h1>
                <p>
                  İş bu “Kullanıcı (Üyelik) Sözleşmesi” (“Sözleşme”),
                  www.cargologi.com yani bu web sitesinin (“Site”) ve burada
                  sunulan yazılımların ve hizmetlerin (“Hizmet(ler)”)
                  kullanımını düzenlemektedir.
                </p>
                <p>
                  Sözleşme, kullanıcının (Üyenin) elektronik ortamda kabulü ile
                  yürürlüğe girecek olup; taraflarca Sözleşme ’de belirtilen
                  usuller doğrultusunda sona erdirilmediği sürece yürürlükte
                  kalmaya devam edecektir. İş bu Sözleşme, üyenin münferit
                  abone, tek bir şirket veya kuruluş (“Üye(ler)”) olması fark
                  etmeksizin, kullanıcı olan Üye ve “CARGOLOGi GLOBAL LOJİSTİK
                  ANONİM ŞİRKETİ” kısaca markası ve web sayfa ismi ile
                  “CARGOLOGİ” ) arasında gerçekleşen yasal bir sözleşmedir.
                </p>
                <p>
                  Kullanıcı (Üye), web sitemize üye olmakla birlikte, işbu
                  sözleşme ile bağlı olduğunu kabul etmiş olup Kullanıcı
                  (Üyelik) Bilgilerinin, aşağıda ve web sayfasında yer verilen
                  KVKK ’da belirtilen şekilde toplanmasını ve kullanılmasını da
                  kabul etmiş sayılacaktır.{" "}
                  <Link to="www.cargologi.com/kvkk/ ">KVKK</Link>
                </p>
                <p>
                  Eğer kullanıcı (üye); bir şirket, kuruluş veya tüzel kişi
                  adına bir hesap açıyor veya kullanıyorsa: (i) iş bu
                  sözleşmeyle bağlı olacak şekilde o kurumun yetkili temsilcisi
                  olduğunu; (ii) iş bu sözleşmeyi okuduğunu; (iii) anladığını
                  (iv) tüzel kişi adına onayladığını kabul ve taahhüt etmiş
                  olacaktır.
                </p>
              </article>
              <article>
                <h4>1) Hizmetin Tanımı</h4>
                <p>
                  İşbu Site ve burada sunulan Hizmetler “CARGOLOGİ GLOBAL
                  LOJİSTİK ANONİM ŞİRKETİ” ‘ne ( kısaca markası ve web sayfa
                  ismi ile “CARGOLOGİ” ) ait olup, perakendecilikle uğraşanlar
                  için sipariş karşılama ve gönderim sürecini kolaylaştıran web
                  tabanlı bir nakliye çözümüdür. Popüler pazarlara ve site
                  üzerinde kamuya duyurulan alışveriş platformlarına gerçek
                  zamanlı entegrasyonlarla, sipariş alma ve toplu etiket
                  oluşturmadan müşteri iletişimine kadar her türlü faaliyeti
                  gerçekleştirmektedir. Gelişmiş özelleştirme seçenekleri,
                  CARGOLOGİ ‘nin işletmelere istenilen sayıda kullanıcı veya
                  konumla uyum sağlamasını destekler. CARGOLOGİ ’nin yazılımını
                  ve yazılım dışında sunulan lojistik hizmetinden de
                  faydalananlar “Üye” olarak adlandırılmaktadır. Her üyenin
                  aldığı hizmetlerin, ücret ve koşullar birbirinden farklıdır.
                </p>
                <br />
                <p>
                  Yürütme, planlama, organize etme, iptal etme, yeni hizmet
                  ekleme, veya var olan hizmetleri sonlandırma vb. tüm süreçlere
                  ilişkin hakları CARGOLOGİ GLOBAL LOJİSTİK ANONİM ŞİRKETİ saklı
                  kalmak üzere CARGOLOGİ platformunda verilen temel ve ek
                  hizmetler aşağıdaki şekilde tanımlanmaktadır.
                  <br />
                  <br />
                  Sipariş Alma : CARGOLOGİ internet sitesi aracılığı ile
                  kullanıcı (üye)’nin, bir emtianın kendisine ulaştırılması veya
                  kendisi namına belirli bir adresten alınması için başvuruda
                  bulunması amacıyla yaptığı başvuru sonucunda, CARGOLOGİ ’nin
                  bu emtianın ilgili noktadan fiziken teslim alınması için
                  gerekli organizasyon ve planlamaların tümünü,
                  <br />
                  <br />
                  Etiketleme/Toplu Etiketleme : CARGOLOGİ ’nin, bir kullanıcı
                  (üye) talimatıyla, fiziken aldığı gönderiye, etiket, barkod
                  vb. materyallerin yapıştırılmasını,
                  <br />
                  <br />
                  Ambalajlama : CARGOLOGİ ’nin, bir kullanıcı (üye) talimatıyla
                  fiziken telsim aldığı gönderiyi belirli bir ücret karşılığında
                  dış çevre koşulları (nem, sıcaklık, soğukluk, ıslanma, hava
                  teması) etkilenmeyecek şekilde dış paket-çevre ambalaj ile
                  kaplanması veya yeniden kaplanmasını,
                  <br />
                  <br />
                  Nakliye ve Taşıma : CARGOLOGİ ’nin; bir kullanıcı (üye) talebi
                  doğrultusunda, kendisine teslim edilen ve kendisinin teslim
                  alması talep edilen yükün, kullanıcı (üye)’nin bildirdiği
                  varış noktasına ulaştırılması için 3. taraf lojistik hizmet
                  sağlayıcılar aracılığı ile fiilen taşınması için gerekli tüm
                  organizasyonu,
                  <br />
                  <br />
                  Depozito (CargoBakiye) : CARGOLOGİ ’nin, kullanıcılarına
                  (üyelerine), sunduğu/sunacağı hizmetler ve üyelik hizmetine
                  ilişkin işbu sözleşme içerisinde Kullanıcı (Üye)
                  sorumluluğunda tanımlanan her türlü ücretin, Kullanıcı (Üye)
                  tarafından kolaylıkla geçekleştirilebilmesi amacıyla CARGOLOGİ
                  tarafından oluşturulan önden üyenin depozito bakiyeyi
                  CARGOLOGİ hesaplarına göndermesi sonrası sanal ödeme
                  yöntemini,
                  <br />
                  <br />
                  Gönderi Takibi : CARGOLOGİ, bir kullanıcı (üye)’nin CARGOLOGİ
                  üzerinden nakliye ve taşıma hizmetini aldığı durumda,
                  oluşturulan gönderiye ilişkin 3. Taraf Lojistik Hizmet
                  Sağlayıcılar fiilen taşınan gönderilere ilişkin sağlanan
                  gönderi kodu vasıtasıyla kullanıcıya (üye)’ye, 3. Taraf
                  Lojistik Hizmet Sağlayıcılar tarafından gönderinin tabi
                  tutulduğu lojistik süreç ve aşamaların iletilmesine aracılık
                  etmesini ifade etmektedir.
                  <br />
                  <br />
                  Fiyat Teklifi : CARGOLOGİ, kullanıcı (üye) ‘ya site’de ki
                  Gönderi Oluştur ve Entegre Gönderi Oluştur menülerinden
                  kullanıcı (üye) ‘nin girmiş olduğu alıcı adres, posta kodu ve
                  gönderi ölçü ve ağırlığına göre teklifleri sunar. Bu fiyat
                  teklifi kullanıcı (üye) ‘nin verdiği bilgilere göre oluşan ve
                  oluşturduğu zaman ki maliyetlere göre verilmiş tekliftir. Ana
                  taşıyıcı olan CARGOLOGİ ’nin tedarikçilerinin fiyat
                  güncellemesi durumunda, kullanıcı (üye) ’ye uygulanacak olan
                  satış fiyatı da güncellenecektir. Maliyet değişikliklerinde
                  henüz CARGOLOGİ merkezinden tedarikçilere teslim edilmemiş
                  gönderilerin satış ücretleri güncellenir ve fiyat farkı varsa
                  kullanıcı (üye) ‘den talep ve tahsil edilerek gönderinin
                  çıkışı ödeme tamamlandıktan sonra çıkış yapar.
                  <br />
                  <br />
                  Etiket Oluşturma ve Depo ’ya Gönderme : Kullanıcı (üye)
                  CARGOLOGİ web sayfasında gönderi oluşturduğunda verilen teklif
                  CARGOLOGİ Merkez ve/veya Depo ofisinden çıkarak yurt dışında
                  kullanıcı (üye) ‘nin belirttiği adrese teslimatı için
                  verilmiştir. Hazırlanan gönderi ve/veya gönderilerin
                  kullanıcı(üye) ‘nın toplama adresinden CARGOLOGİ Merkez
                  ve/veya CARGOLOGİ Depo adresine ulaştırılması için 3. Taraf
                  lojistik hizmet sağlayıcılardan kullanıcı(üye) tarafından
                  CARGOLOGİ ‘ye ait cari, müşteri numarası veya hesap numarası
                  ile hizmet alırsa bu ilave hizmet 3. taraf lojistik hizmet
                  sağlayıcılar tarafından CARGOLOGİ ‘ye fatura edilir. Bu
                  nedenle oluşacak bu ilave hizmet için kullanıcı (üye) ‘ya
                  fatura edilmek üzere ek ücret oluşur. Kullanıcı (üye) oluşacak
                  bu ek ücreti gönderi yurt dışı edilmeden CARGOLOGİ’nin
                  belirlediği ücreti ödemeyi gönderi en başta gönderi
                  oluşturduğunda peşin olarak ödeyeceğini kabul ve taahhüt eder.
                  <br />
                  <br />
                </p>
                <p>
                  Kullanıcı (üye), Md.1.2. altında tanımlanan hizmetlerin
                  kendisine sunulması için sözleşme içerisinde belirtilen (Bkz.
                  3. Kullanıcı Hak ve Yükümlülükleri ve alt maddeleri)
                  yükümlülüklerini yerine getirmek zorundadır. Aksi durumda
                  hizmet süreci kısmen başlatılmış ise dahi, CARGOLOGİ
                  tarafından tek taraflı şekilde sonlandırılabilir.
                </p>
                <p>
                  İşbu sözleşme uyarınca, Kullanıcı (üye), Md.1.2. altında
                  tanımlanan ve faydalandığı hizmetlerin içeriklerini kabul
                  etmiş sayılır. Gönderinin durumu gereği, İlgili tanımlama
                  haricinde işlemleri veya süreçlerin temini gerektirmesi
                  durumunda, bu işlem ve süreçlerin CARGOLOGİ ‘den talep
                  edilmeyeceği veya CARGOLOGİ ‘den yerine getirilmeyeceğini
                  kabul etmiş sayılır.
                </p>
              </article>
              <article>
                <h4>2) Site ve Hizmete Dair Genel Bilgiler</h4>
                <p>
                  2.1. CARGOLOGİ, site ’de ki bilgilerin doğruluğunu ve
                  güncelliğini sürekli olarak kontrol eder. Ancak, gösterilen
                  tüm çabalara rağmen ortaya çıkan yazım, yazılım ve sistem
                  hatalarından CARGOLOGİ sorumlu değildir. Üye erişimin yazım
                  veya sistem hatalarından kesilebileceğini ve bu süreçte ortaya
                  çıkabilecek zarar, gecikme vb. durumlardan CARGOLOGİ 'nin
                  sorumlu olmadığını kabul eder.
                </p>
                <p>
                  2.2. CARGOLOGİ, site’de yer alan veya alacak olan bilgileri,
                  formları, içeriği ve iş bu Kullanıcı(Üyelik) Sözleşmesi’ni
                  dilediği zaman değiştirme hakkını saklı tutmaktadır.
                </p>
                <p>
                  2.3. CARGOLOGİ, hesapları feshedebilir, Hizmete gönderilen tüm
                  içeriği veya bilgileri silebilir ve / veya herhangi bir
                  sebepten dolayı Hizmet ’in (veya Hizmet ’in herhangi bir
                  kısmının veya özelliğinin) kullanımını veya erişimini herhangi
                  bir zamanda, kendi takdirine bağlı olarak, bildirimde
                  bulunarak veya bulunmayarak engelleyebilir. CARGOLOGİ ‘nin
                  herhangi bir sebepten ötürü Site ’de yer alan herhangi bir
                  hesabı (tamamen veya kısmen) feshetmesi kendi
                  inisiyatifindedir. Ayrıca, CARGOLOGİ, herhangi bir üye
                  verisinin görüntülenmesini durdurma hakkı da dahil olmak üzere
                  Hizmet ’in herhangi bir yönünü durdurma hakkını saklı tutar.
                </p>
                <p>
                  2.4. Site diğer web sitelerine bağlantılar içerebilir
                  ("Bağlantılı Siteler"). Bağlantılı Sitelerde, CARGOLOGİ ‘nin
                  herhangi bir kontrolü ve sorumluluğu bulunmamaktadır.
                </p>
                <p>
                  2.5. Taşıma, Nakliye ve Depolama Hizmetleri kapsamında, Türk
                  Ticaret Kanunu ve/ veya ilgili ülke mevzuatları ile birlikte
                  lojistik ve taşıma süreçlerinde uygulama alanı bulan
                  uluslararası mevzuatlar uyarınca yasaklanmış bulunan ürünlerin
                  gönderilmesi talepleri karşılanmayacak olup CARGOLOGİ ‘nin söz
                  konusu hallerde Siteye ve ilgili hizmetlere erişimi engelleme
                  hakkı bulunmaktadır.
                </p>
                <p>
                  2.5.1. CARGOLOGİ ’ye kullanıcı tarafından teslim edilen bir
                  paket içeriğinde, herhangi bir mevzuat açısından yasaklı
                  içerik olduğu taşıma-nakliye-depolama ve tüm lojistik süreç
                  içerisindeki herhangi bir aşamada tespit edilen gönderiler
                  sebebiyle doğabilecek herhangi bir cezai durumda CARGOLOGİ’nin
                  sorumluluğu olmayıp; kullanıcı (üye) gönderdiği ürün ve ürüne
                  ilişkin beyanının yasa dışı olmasından doğacak tüm
                  sorumlulukları kabul etmiş sayılır.
                </p>
                <p>
                  2.5.2. CARGOLOGİ tarafından; işbu kullanıcı sözleşmesi
                  kapsamında Md. 1.2. içeriğinde tanımlanan temel ve ek faaliyet
                  alanlarına konu olacak gönderilerin içeriğine ilişkin,
                  kendisine teslim anı veya sonrasında kontrol yükümlülüğü,
                  zorunluluğu bulunmamaktadır. Kullanıcı (üye), CARGOLOGİ ’nin
                  bu şekilde bir yükümlülüğü olmadığını ve gönderiye ilişkin
                  içerik beyanlarından doğacak her türlü olumsuz sonucu kabul
                  etmiş sayılır.
                </p>
                <p>
                  2.6. CARGOLOGİ, verdiği hizmet ile Kullanıcı (Üye)’ye taahhüt
                  ettiği hizmetleri yerine getirirken gönderide meydana gelecek
                  zarar (kısmi ve/veya tam zayi, hasar, gecikme vb.) veya
                  herhangi bir hizmet aksaklığından kaynaklanan taraflar arası
                  ihtilafta, öncelikli olarak ilgili nakliye-taşıma sürecinde
                  Türkiye Cumhutiyeti’nin taraf olduğu uluslararası mevzuat
                  uygulanacak olup; bu mevzuat kapsamında bulunmayan hallerde
                  ulusal mevzuat uygulanacaktır.
                </p>
                <p>
                  2.7. CARGOLOGİ, üye tarafından kendisi ile paylaşılan bilgi ve
                  verileri işbu Sözleşme ’ye ek niteliğinde olan “Gizlilik
                  Politikası” kapsamında saklayacak ve kullanacaktır. Üye,
                  CARGOLOGİ ’nin yürürlükteki mevzuat uyarınca yetkili
                  makamlardan talep gelmesi halinde üye ’nin kendisinde bulunan
                  bilgilerini ilgili yetkili makamlarla paylaşabileceğini kabul
                  eder.
                </p>
                <p>
                  2.8. CARGOLOGİ, üyeyi bilgilendirmeden gerekli gördüğü sistem
                  değişikliklerini, güncellemelerini ve kısıtlamalarını
                  değiştirme hakkını saklı tutar.
                </p>
              </article>
              <article>
                <h4>3) Kullanıcının Hak ve Yükümlülükleri</h4>
                <p>
                  3.1. Üye, Kullanıcı (Üyelik) hesabını ve işbu Sözleşme ile
                  Site kullanımından doğan hak ve yükümlülüklerini herhangi bir
                  şekilde üçüncü bir kişiye devir veya temlik edemez. CARGOLOGİ
                  ’nin sunduğu Hizmetler’den yararlananlar ve Site 'yi
                  kullananlar, yalnızca hukuka uygun ve şahsi/kurumsal amaçlarla
                  Site üzerinden işlem yapabilirler. Üye 'nin, Site kapsamında
                  gerçekleştirdiği her işlem ve eylemdeki hukuki ve cezai
                  sorumluluk kendisine aittir.
                </p>
                <p>
                  3.2. Üye tarafından Site ’ye erişim e-posta adresi ve şifresi
                  kullanılarak gerçekleştirilecektir. Bu şifrenin gizliliğinin
                  ve güvenliğinin korunmasından üye sorumlu olacak olup Site
                  üzerinden söz konusu bilgilerin kullanımı ile gerçekleştirilen
                  her türlü faaliyetin üye tarafından gerçekleştirildiği kabul
                  edilecek ve aynı zamanda bu faaliyetlerden doğan her türlü
                  yasal ve cezai sorumluluk üye ’ye ait olacaktır. Üye,
                  şifresinin yetkisiz kullanımı veya güvenliğin başka şekilde
                  ihlalinden haberdar olduğunda bu durumu derhal CARGOLOGİ ’ye
                  bildirecektir. Üye, sadece tanıtım, reklam, kampanya,
                  promosyon, duyuru vb. pazarlama faaliyetleri kapsamında
                  kullanılması ile sınırlı olmak üzere, CARGOLOGİ ’nin,
                  kendisine ait iletişim, portföy durumu ve demografik
                  bilgilerini iştirakleri ya da bağlı bulunduğu şirketler ile
                  paylaşmasına muvafakat ettiğini kabul ve beyan eder. Bu
                  kişisel bilgiler CARGOLOGİ bünyesinde müşteri profili
                  belirlemek, müşteri profiline uygun promosyon ve kampanyalar
                  sunmak ve istatistiksel çalışmalar yapmak amacıyla
                  kullanılabilecektir. Üye, içerik ve diğer bilgilerin CARGOLOGİ
                  veya üçüncü kişiler tarafından Türkiye’de veya yurt dışında
                  bulunan veri merkezlerinde saklanabileceğini kabul eder.
                </p>
                <p>
                  3.3. Üye kendisine site içerisinde bildirilen gönderi ve/veya
                  paket ve/veya ürün takip numarası ile gönderisini ve/veya
                  paketini ve/veya ürününü takip etmek ve herhangi bir durumda (
                  Adres hatası, gümrüklü işlem dolayısı ile gecikme ve benzeri)
                  gerek alıcı gerek CARGOLOGİ ile yazılı iletişime geçerek
                  konunun çözümü için bilgi vereceğini ve gönderisini yurtdışına
                  taşıyan ana taşıyıcılara ( DHL, UPS, Fedex, TNT, USPS, Royal
                  Mail, Deutschepost, GLS, DPD ve benzeri alanda ki diğer
                  firmalara ) ait web sayfalarından bizzat takip etmek ile
                  sorumludur. Üye, gerek kendi gerek gönderinin nihai alıcısının
                  takipsizlik iletişimsizliği sonucu oluşacak herhangi bir
                  masraf veya durumdan CARGOLOGİ ‘yi sorumlu tutmayacağını kabul
                  eder.
                </p>
              </article>
              <article>
                <h4>4) Fikri Mülkiyet Hakları</h4>
                <p>
                  4.1. Üye, Site ’de ve verilen Hizmet ’te tüm fikri mülkiyet
                  haklarının CARGOLOGİ ’ye ait olduğunu kabul ve beyan eder.
                </p>
                <p>
                  4.2. İşbu Kullanıcı(Üyelik) Sözleşmesi dahilinde CARGOLOGİ
                  tarafından sarahaten izin verilen durumlar haricinde, üyeler,
                  CARGOLOGİ ’nin telif haklarına tabi çalışmalarını çoğaltamaz,
                  işleyemez, dağıtamaz veya bunlardan türemiş çalışmalar yapamaz
                  veya hazırlayamaz.
                </p>
              </article>
              <article>
                <h4>5) Mücbir Sebepler</h4>
                <p>
                  CARGOLOGİ, hukuken mücbir sebep sayılan tüm durumlarda, işbu
                  sözleşme içeriğinden, sözleşmede belirtilen temel ve ek
                  faaliyetlerden ve gizlilik politikasından doğan
                  yükümlülüklerinden herhangi birini tam olarak ve zamanında ifa
                  edememekten dolayı sorumlu değildir. Böyle bir hususun varlığı
                  halinde CARGOLOGİ ’nin herhangi bir tazminat sorumluluğu
                  doğmayacaktır.
                </p>
              </article>
              <article>
                <h4>6) Ücretler ve Vergiler</h4>
                <p>
                  Üyelik dahilinde üyeye özel tanımlanan ücretler, CARGOLOGİ ’ye
                  abone olan üyeler için geçerli olacak olup, CARGOLOGİ farklı
                  ücretler belirlemek hakkını haizdir.
                </p>
                <p>
                  6.1. İşbu sözleşmenin 1. Maddesi içeriğinde sayılan temel ve
                  ek hizmetler ile tarafların bunlar dışında mutabık kaldığı
                  diğer hizmetlere ilişkin, ödeme ve vergi gibi ücretlerin
                  geçerli bir ödeme yöntemiyle ve zamanında ödenmesinden
                  Kullanıcı (Üye) sorumludur. Aksi belirtilmedikçe, tüm
                  ücretler ABD(Amerikan) Doları, AVRO(Euro) ve POUND(İngiliz
                  Poundu) para cinsindendir. Ve ödemenin yapılacağı gün ki
                  efektif satış döviz kuru ile üye tarafından ödenir. Satış Türk
                  Lirası üzerinden yapılır. Tüm ödemeler Hizmet içerisinde
                  belirtilen yöntemlerle yapılmalıdır. Tüm ücretler ve masraflar
                  tarafımızdan alındıktan sonra kazanılır ve (a) açıkça
                  belirtildiği durumlarda ve / veya (b) yürürlükteki yasaların
                  gerektirdiği haller dışında, iade edilemez.
                </p>
                <p>
                  6.2. Kullanıcı (Üye) satış, kullanım veya katma değer vergisi
                  gibi Hizmet 'i kullanmasına dair öngörülen herhangi bir devlet
                  vergisini ödemekle yükümlüdür. CARGOLOGİ 'nin bu tür vergileri
                  tahsil etmek zorunda olduğu ölçüde, geçerli vergi,
                  faturalandırma hesabına eklenecektir ve üyeden tahsil
                  edilecektir. CARGOLOGİ, yurtdışından iade olarak gelen gönderi
                  navlun ücretlerini, 3. taraf Lojistik Hizmet Sağlayıcıları
                  firmaların sonradan gönderi ile ilgili CARGOLOGİ ‘ye fatura
                  ettiği ek ücretleri, Türkiye veya yurtdışında oluşan vergi,
                  ceza vb. tüm masrafları üyeden tahsil edecektir. Üye bu
                  tahsilatı en başından gönderiyi yurtdışına gönderirken kabul
                  etmiş sayılmaktadır ve üye’nin www.cargologi.com web sayfası
                  içinde kendine özel panelinde kendisine tebliğ edildiği gün
                  itibari ile 7 gün içinde ödeyeceğini kabul ve taahhüt eder.
                </p>
                <p>
                6.3. Kullanıcı (Üye)’nin CargoBakiye ‘ye yaptığı para ve bakiye yüklemeleri önden ödeme (depozito) niteliğindedir. CARGOLOGİ ’nin sunduğu hizmet sonrası, alacağı oluşması durumunda tüm alacak bakiyesini üye ’ye ait olan CargoBakiye özelliğinde bulunan fazla bakiyeden tahsil etme hakkına sahiptir, üye bu tahsilat için CARGOLOGİ ’ye sözleşmenin kabul edildiği andan itibaren yetki vermiş sayılır.  
                </p>
                <p>
                6.4. Kullanıcı (Üye)’ye ait olan CargoBakiye yani önden ödediği depozito bakiye özelliğinde borcuna karşılık yeterli miktar bulunmaması durumunda kredi kartı, eft/havale veya nakit olarak ödeyeceğini taahhüt etmiştir. 
                </p>
                <p>
                6.5. CARGOLOGİ, Kullanıcı (üye)’nin CargoBakiye hizmetinden faydalandığı durumlarda, işbu sözleşme içeriğinde 6.1. ve 6.2. maddelerinde belirtilen ödemeleri Kullanıcı(Üye)’ye önceden bildirim yapmak kaydıyla, Kullanıcı (Üye)’ye ait CargoBakiye ‘de ki bakiyesinden tahsil etme hakkına sahiptir.
                </p>
                <p>
                6.6. Seçilen ödeme yöntemi ile bakiyesinin CARGOLOGİ tarafından tahsil etme yetkisi, hizmet içindeki ödeme tercihleri iptal edilinceye veya değiştirilinceye dek yürürlükte kalacaktır; Ancak, böyle bir bildirim, CARGOLOGİ 'nin makul bir şekilde harekete geçmesinden önce sunulan ücretleri etkilemeyecektir. 
                </p>
                <p>
                6.7. CARGOLOGİ, Hizmet için herhangi bir ücreti, tarifeyi, ücret sınırını veya miktarını değiştirme ve üyelerine önceden bildirimde bulunarak yeni ücret veya şartlar oluşturma hakkını saklı tutar. Herhangi bir üyelik süresi için ücretler peşin olarak ödenir ve tamamen veya kısmen iade edilmez. 
                </p>
                <p>
                6.8. Hizmet iptal edilmediği müddetçe aylık üyelik her ayın sonunda, yıllık üyelik ise her yıl dönümü bitiminde otomatik olarak yenilenecektir. 
                </p>
                <p>
                6.9. Yıllık üyelikler için, yıllık yenileme tarihinden en az 30 gün önce, aboneliğin iptal edilmek istendiği bildirilmelidir. Aylık üyelikler için ise yedi (7) gün öncesinde bildirim yapmak gerekmektedir.
                </p>
                <p>
                6.10. Kullanıcı (Üye) herhangi bir sebepten ötürü (Yasalara aykırı içerik veya alt tedarikçi kurye ve/veya lojistik depolama firmalarının kararları nedeni ile) yurtdışına çıkartılamamış gönderiler ile ilgili; Kullanıcı (Üye)’den  CARGOLOGİ ’in adresine ulaştırılması esnasında oluşan her türlü lojistik hizmet (taşıma, depolama, kiralama, araç temini, elleçleme, yükleme-boşaltma vb.) ve buna ilave  varsa bu süreçte oluşan cezai yaptırımları ödeyeceğini peşinen kabul etmiştir. Bu süreçte oluşacak Lojistik Hizmet Organizasyonundan doğan ücretlerin tutarlarını belirleme hakkını CARGOLOGİ kendisinde saklı tutar.
                </p>
              </article>
              <article>
                <h4>7) Sözleşmenin Sonlandırılması</h4>
                <p>
                7.1. Taraflardan herhangi biri, diğer tarafça bildirilen elektronik posta adresine 1 (bir) hafta önceden yapacağı yazılı bir bildirimle işbu Sözleşme’yi dilediği zaman herhangi bir gerekçe göstermeksizin ve tazminat ödemeksizin feshedebilecektir.
                </p>
                <p>
                7.2. İşbu Sözleşme’nin herhangi bir hükmünün veya sözleşmede yer alan herhangi bir ifadenin geçersizliği, yasaya aykırılığı ve uygulanamazlığı, Sözleşme’nin geri kalan hükümlerinin yürürlüğünü ve geçerliliğini etkilemeyecektir. 
                </p>
                <p>
                7.3. İşbu Sözleşme’nin uygulanmasından veya yorumlanmasından doğacak her türlü uyuşmazlığın çözümünde İstanbul Çağlayan Adliyesi Mahkemeleri ve İcra Daireleri yetkilidir.
                </p>
              </article>
            </section>
          </main>
          <footer>
            <Button className="iyzi-button-red" onClick={handleTermsReject}>
              Kabul Etmiyorum
            </Button>
            <Button
              style={{ backgroundColor: "var(--success)" }}
              className="iyzi-button-blue"
              onClick={handleTermsAccept}
            >
              Kabul Ediyorum
            </Button>
          </footer>
        </Box>
      </Fade>
    </Modal>
  );
};

export default RegisterModal;
